<template src="./LoginModal.html"></template>
<style lang="scss" scoped src="./LoginModal.scss"></style>

<script>

import {
  SfHeading,
  SfIcon,
  SfModal,
  SfButton,
  SfTabs,
  SfBar,
  SfLink,
  SfImage,
  SfDivider,
  SfNotification
} from '@storefront-ui/vue';
import LogIn from '@/components/AccountForm/LogIn'
import ForgotPassword from '@/components/AccountForm/ForgotPassword'
import SignIn from '@/components/AccountForm/SignIn'
import Api from "@/api/Api";
import icons from "@/utils/icons";
import AuthFactor from "@/components/AccountForm/AuthFactor";
import LogInGpNet from "@/components/GpnetForm/LogIn";
import AuthFactorGpnet from "@/components/GpnetForm/AuthFactor";
import ForgotPasswordGpnet from "@/components/GpnetForm/ForgotPassword";
import SignInGpnet from "@/components/GpnetForm/SignIn";

export default {
  name: 'LoginModal',
  components: {
    SfNotification,
    ForgotPassword,
    SfDivider,
    SfImage,
    LogIn,
    SignIn,
    SfModal,
    SfTabs,
    SfButton,
    SfBar,
    SfLink,
    SfIcon,
    SfHeading,
    AuthFactor,
    SignInGpnet,
    ForgotPasswordGpnet,
    AuthFactorGpnet,
    LogInGpNet
  },
  data() {
    return {
      isLogin: true,
      isAuth: false,
      isForgot: false,
      createAccount: false,
      openTab: 1,
      icons: icons,
      customerForm: null,
      isDefaultGpnet: true,
      isLoginGpNet: false,
      gpnet: false,
      isAuthGpnet: false,
      isForgotGpnet: false,
    }
  },

  computed: {
    isLoginModalOpen: {
      get() {
        return this.$store.getters.isLoginModalOpen
      }
    },
  },

  methods: {

    habileConnect() {
      this.gpnet = false;

      const url = process.env.VUE_APP_HABILE_HTTP_VERSION + '://' + process.env.VUE_APP_HABILE_HOST + process.env.VUE_APP_HABILE_API_ROUTE + 'authorization.oauth2?client_id=' + process.env.VUE_APP_HABILE_CLIENT_ID + '&redirect_uri=' + process.env.VUE_APP_HABILE_REDIRECT_URI + '&response_type=code&scope=openid email';
      this.toggleModal();
      window.location.href = url;

    },
    toggleModal() {
      this.isLogin = true;
      this.isAuth = false;
      this.isDefaultGpnet = true;
      this.isForgot = false;
      this.isLoginGpNet = false;
      this.gpnet = false;
      this.isAuthGpnet = false;
      this.isForgotGpnet = false;
      this.createAccount = false;
      this.$store.dispatch('toggleLoginModal', {open: !this.isLoginModalOpen.open})
    },
    gpnetConnect() {
      this.gpnet = true;
    },
    loginForm({form, onComplete, onError}) {
      this.customerForm = form;

      Api.account.login(form)
          .then((data) => {
            onComplete(data)


            if (data.twoFactorAuthenticationEnabled) {
              this.isAuth = true;
              this.isLogin = false;
            } else {
              this.isAuth = false;
              this.isLogin = true;
              this.$store.dispatch('loginCustomer', data);
              this.$store.dispatch('toggleLoginModal', {open: false});
              this.$store.dispatch('toggleWelcomeModal', {
                open: true,
                customer: data
              });
              this.$store.dispatch('getCategoryTree');
            }
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 429: {
                const hoursToWait = Math.floor(e.errorData.retryAfter / 3600);
                const minutesToWait = Math.floor(e.errorData.retryAfter / 60);
                const secondsToWait = (e.errorData.retryAfter % 60) + 1;

                if (hoursToWait > 0) {
                  error = this.$i18n.t('errors.login.rateLimit.hoursAndMinutes', [hoursToWait, minutesToWait])
                } else if (minutesToWait > 0) {
                  error = this.$i18n.t('errors.login.rateLimit.minutesAndSeconds', [minutesToWait, secondsToWait])
                } else {
                  error = this.$i18n.t('errors.login.rateLimit.seconds', [secondsToWait])
                }
              } break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })

    },

    signinForm({form, onComplete, onError}) {
      Api.account.register(form)
          .then((data) => {
            onComplete(data)
            this.$store.dispatch('loginCustomer', data);
            this.$store.dispatch('toggleLoginModal', {open: false});
            this.$store.dispatch('toggleWelcomeModal', {
              open: true,
              customer: data
            });
            this.$store.dispatch('getCategoryTree');
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })
    },

    forgotForm({form, onComplete, onError}) {
      Api.account.resetPassword(form)
          .then((data) => {
            onComplete(data)
            this.$store.dispatch('toggleLoginModal', {open: false});
            this.$store.dispatch('toggleResetModal', {
              open: true,
              email: form.email
            });

          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })

    },

    authSubmit({oneTimePassword, onComplete, onError}) {

      this.customerForm.oneTimePassword = oneTimePassword
      Api.account.loginOneTimePassword(this.customerForm)
          .then((data) => {
            onComplete(data)
            this.isAuth = false;
            this.isLogin = true;
            this.$store.dispatch('loginCustomer', data);
            this.$store.dispatch('toggleLoginModal', {open: false});
            this.$store.dispatch('toggleWelcomeModal', {
              open: true,
              customer: data
            });
            this.$store.dispatch('getCategoryTree');
          })
          .catch((e) => {
            let error = '';
            const messageParts = e.message.split('|')
            const count = messageParts[1]

            switch (messageParts[0]) {
              case "The provided one time password doesn't match":
                error = this.$i18n.t('errors.auth.unauthorized')
                if (!count) {
                  this.isAuth = false;
                  this.isLogin = true
                }
                break;
              case "Too much attempts for one time password":
                error = this.$i18n.t('errors.auth.tooMuch')
                if (!count) {
                  this.isAuth = false;
                  this.isLogin = true
                }
                break;
              case "One time password is expired":
                error = this.$i18n.t('errors.auth.timeOut')
                break;
            }
            switch (e.status) {
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
              case 404:
                error = this.$i18n.t('errors.notfound')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError({message: error, count})
          })
    },

    setIsLoginValue(value) {
      this.isLogin = value;
      this.isForgot = !value;
    },
    setIsForgotValue(value) {
      this.isForgot = value;
      this.isLogin = !value;
    },

    setIsRegisterValue(value) {
      this.isForgot = value;
      this.isLogin = value;
    },

    /* GPnet */
    loginGpnetForm({form, onComplete, onError}) {
      this.customerForm = form;

      Api.account.loginGpNet(form)
          .then((data) => {
            onComplete(data)


            if (data.twoFactorAuthenticationEnabled) {
              this.isAuthGpnet = true;
              this.isLoginGpNet = false;
            } else {
              this.isAuthGpnet = false;
              this.isLoginGpNet = true;
              this.$store.dispatch('loginCustomer', data);
              this.$store.dispatch('toggleLoginModal', {open: false});
              this.$store.dispatch('toggleWelcomeModal', {
                open: true,
                customer: data
              });
              this.$store.dispatch('getCategoryTree');
            }
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
              case 502:
                error = this.$i18n.t('errors.server.gpNet')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })

    },

    signinGpnetForm({form, onComplete, onError}) {
      Api.account.registerGpNet(form)
          .then((data) => {
            onComplete(data)
            this.$store.dispatch('loginCustomer', data);
            this.$store.dispatch('toggleLoginModal', {open: false});
            this.$store.dispatch('toggleWelcomeModal', {
              open: true,
              customer: data
            });
            this.$store.dispatch('getCategoryTree');
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
              case 502:
                error = this.$i18n.t('errors.server.gpNet')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })
    },

    forgotGpnetForm({form, onComplete, onError}) {
      Api.account.resetPasswordGpNet(form)
          .then((data) => {
            onComplete(data)
            this.$store.dispatch('toggleLoginModal', {open: false});
            this.$store.dispatch('toggleResetModal', {
              open: true,
              email: form.email
            });
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
              case 502:
                error = this.$i18n.t('errors.server.gpNet')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })

    },

    authGpnetSubmit({oneTimePassword, onComplete, onError}) {

      this.customerForm.oneTimePassword = oneTimePassword
      Api.account.loginOneTimePasswordGpNet(this.customerForm)
          .then((data) => {
            onComplete(data)
            this.isAuthGpnet = false;
            this.isLoginGpNet = true;
            this.$store.dispatch('loginCustomer', data);
            this.$store.dispatch('toggleLoginModal', {open: false});
            this.$store.dispatch('toggleWelcomeModal', {
              open: true,
              customer: data
            });
            this.$store.dispatch('getCategoryTree');
          })
          .catch((e) => {
            let error = '';
            const messageParts = e.message.split('|')
            const count = messageParts[1]

            switch (messageParts[0]) {
              case "The provided one time password doesn't match":
                error = this.$i18n.t('errors.auth.unauthorized')
                if (!count) {
                  this.isAuth = false;
                  this.isLogin = true
                }
                break;
              case "Too much attempts for one time password":
                error = this.$i18n.t('errors.auth.tooMuch')
                if (!count) {
                  this.isAuth = false;
                  this.isLogin = true
                }
                break;
              case "One time password is expired":
                error = this.$i18n.t('errors.auth.timeOut')
                break;
            }
            switch (e.status) {
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
              case 404:
                error = this.$i18n.t('errors.notfound')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError({message: error, count})
          })
    },

    setIsLoginGpnetValue(value) {
      this.isLoginGpNet = value;
      this.isForgotGpnet = !value;
      this.isDefaultGpnet = !value;
    },
    setIsForgotGpnetValue(value) {
      this.isForgotGpnet = value;
      this.isLoginGpNet = !value;
      this.isDefaultGpnet = !value;
    },

    setIsRegisterGpnetValue(value) {
      this.isForgotGpnet = value;
      this.isLoginGpNet = value;
      this.isDefaultGpnet = value;
    },

  },
}
</script>
